module.exports = __webpack_public_path__ + "e4fd964c4ae8f765841e62bda1572c92.jpg";